import {APIResponse} from "./types";

export interface EventRegistrationCreateRequest {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    event_source: string;
}

export enum EventSource {
    Instagram = "Instagram",
    Facebook = "Facebook",
    Google = "Google",
    TikTok = "TikTok",
    Advertisment = "Advertisment"
}